export const sortByCategoryOrder = <T extends { id: string }>(
  items: readonly T[],
  orderByItemId: Map<string, number>
): T[] =>
  [...items].sort(
    (a, b) =>
      (orderByItemId.get(a.id) ?? Number.MAX_SAFE_INTEGER) -
      (orderByItemId.get(b.id) ?? Number.MAX_SAFE_INTEGER)
  )
